/* The salon's booking page (sections/tih-booking.liquid). Talks only to the shop's booking service
   (booking/app.py), which asks MijnSalon and enforces the salon's rules. One step at a time: treatment, stylist,
   day and time, check and confirm; a bar at the bottom carries the price and the next button. The spam puzzle is
   solved in the background while the customer is on the last step. No libraries. */
(function () {
  var root = document.getElementById('tih-book');
  if (!root) return;
  var API = root.getAttribute('data-api').replace(/\/$/, '');
  var LANG = root.getAttribute('data-lang') === 'en' ? 'en' : 'nl';
  var LOCALE = LANG === 'en' ? 'en-GB' : 'nl-NL';
  var T = JSON.parse(document.getElementById('tih-book-text').textContent);
  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
  var el = function (tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
  var fill = function (s, v) { return s.replace(/\{(\w+)\}/g, function (_, k) { return v[k] != null ? v[k] : ''; }); };
  var STEPS = ['kind', 'who', 'when', 'you'];

  // colourist: with colour and a cut together, who colours (0: whoever is free); colourOpen: the "particular colourist?" row is open
  var state = { screen: 'kind', kinds: [], options: {}, stylist: null, colourist: 0, colourOpen: false, date: null, slot: null, puzzle: null, puzzleAt: 0, me: null, guest: false, open: {}, busy: false };
  var data = { treatments: [], stylists: [], lastDay: null };

  /* ---------------------------------------------------------------- talking to the booking service */
  var SID_KEY = 'tihBookSession';           // the session id only; MijnSalon's token stays with the service
  function sid() { try { return sessionStorage.getItem(SID_KEY); } catch (e) { return null; } }
  function setSid(v) { try { v ? sessionStorage.setItem(SID_KEY, v) : sessionStorage.removeItem(SID_KEY); } catch (e) {} }
  function call(path, body) {
    var h = body ? { 'Content-Type': 'application/json' } : {}, s = sid();
    if (s) h['X-Booking-Session'] = s;
    return fetch(API + path, body ? { method: 'POST', headers: h, body: JSON.stringify(body) } : { headers: h })
      .then(function (r) { return r.json().catch(function () { return { ok: false, error: 'down' }; }); })
      .then(function (r) { if (r && r.error === 'session' && s) { setSid(null); loggedOut(true); } return r; });
  }
  function ask() { return { kinds: state.kinds, options: state.options, stylist: state.stylist || 0, colourist: split() ? state.colourist || 0 : 0 }; }

  /* ---------------------------------------------------------------- money, time, names */
  function eur(v) { return '€' + v.toFixed(2).replace('.', ',').replace(',00', ''); }
  function hhmm(v) { var h = Math.floor(v), m = Math.round((v - h) * 60); return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0'); }
  function byId(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return null; }
  function kind(id) { return byId(data.treatments, id) || {}; }
  function both(names) { return names.length > 1 ? names.slice(0, -1).join(', ') + ' ' + T.and + ' ' + names[names.length - 1] : names.join(''); }
  function dayName(iso, opts) { return new Date(iso + 'T12:00:00').toLocaleDateString(LOCALE, opts); }
  function weekday(n) { return new Date(2026, 0, 4 + n).toLocaleDateString(LOCALE, { weekday: 'long' }); }   // 5 Jan 2026 is a Monday: n 1..7
  function ordered() {                       // colour before the cut, as the service books it
    return state.kinds.slice().sort(function (a, b) { return (kind(b).colour ? 1 : 0) - (kind(a).colour ? 1 : 0) || state.kinds.indexOf(a) - state.kinds.indexOf(b); });
  }
  function priceOf(id) {
    var k = kind(id), o = state.options[id];
    if (k.options && k.options.length) return o != null ? { v: k.options[o].price, from: false } : { v: k.price, from: true };
    return { v: k.price, from: !!k.from };
  }
  function total() {
    var sum = 0, from = false, known = true;
    state.kinds.forEach(function (id) { var p = priceOf(id); if (p.v == null) known = false; else sum += p.v; if (p.from) from = true; });
    return { sum: sum, from: from, known: known && state.kinds.length > 0 };
  }
  // the real length: the work plus the colour's processing time (45 + 45 for colour, then the cut)
  function minutes() { return state.kinds.reduce(function (a, id) { return a + (kind(id).minutes || 0) + (kind(id).processing || 0); }, 0); }
  function duration(n) {
    if (n < 60) return fill(T.minutes, { n: n });
    var h = Math.floor(n / 60), m = n % 60;
    return m ? fill(T.durHM, { h: h, m: m }) : fill(T.durH, { h: h });
  }
  function split() {                         // colour and a cut together: each can have its own stylist
    var c = state.kinds.filter(function (id) { return kind(id).colour; }).length;
    return c > 0 && c < state.kinds.length;
  }
  function common(ids) {
    return ids.reduce(function (acc, id) {
      var s = kind(id).stylists || [];
      return acc === null ? s.slice() : acc.filter(function (x) { return s.indexOf(x) >= 0; });
    }, null) || [];
  }
  function colourIds() { return state.kinds.filter(function (id) { return kind(id).colour; }); }
  function colourists() { return split() ? common(colourIds()) : []; }
  function stylistName() {
    if (state.slot && state.slot.with && state.slot.with.length) return both(state.slot.with);
    var s = state.stylist && byId(data.stylists, state.stylist), c = split() && state.colourist && byId(data.stylists, state.colourist);
    if (c && s && c.id !== s.id) return both([c.name, s.name]);
    return s ? s.name : '';
  }

  /* ---------------------------------------------------------------- step 1: treatments */
  function renderKinds() {
    var box = $('[data-kinds]'); box.textContent = '';
    data.treatments.forEach(function (k) {
      var row = el('div', 'tih-book__kind'); row.setAttribute('data-kind', k.id);
      var lab = el('label', 'tih-book__kind-main');
      var input = el('input'); input.type = 'checkbox'; input.value = k.id; input.checked = state.kinds.indexOf(k.id) >= 0;
      input.addEventListener('change', function () { toggleKind(k.id, input); });
      var txt = el('span', 'tih-book__kind-txt');
      txt.appendChild(el('span', 'tih-book__kind-name', k.name));
      if (k.price != null) {
        var pr = el('span', 'tih-book__kind-price');
        if (k.from) pr.appendChild(el('span', 'tih-book__kind-from', T.from));
        pr.appendChild(document.createTextNode(eur(k.price))); txt.appendChild(pr);
      }
      var tags = [];
      if (k.note) tags.push(k.note);
      if (k.latest) tags.push(fill(T.latest, { time: k.latest }));
      if (tags.length) txt.appendChild(el('span', 'tih-book__kind-note', tags.join(' · ')));
      lab.appendChild(input); lab.appendChild(txt); row.appendChild(lab);
      if (k.options && k.options.length) row.appendChild(renderOptions(k));
      box.appendChild(row);
    });
  }
  function renderOptions(k) {
    var wrap = el('fieldset', 'tih-book__options'); wrap.hidden = state.kinds.indexOf(k.id) < 0;
    wrap.appendChild(el('legend', '', T.chooseOption));
    k.options.forEach(function (o, i) {
      var lab = el('label', 'tih-book__option'), r = el('input');
      r.type = 'radio'; r.name = 'opt-' + k.id; r.value = i; r.checked = state.options[k.id] === i;
      r.addEventListener('change', function () { state.options[k.id] = i; invalidate('kind'); update(); });
      lab.appendChild(r);
      var t = el('span', 'tih-book__option-label', o.label);
      if (o.noDays && o.noDays.length) t.appendChild(el('span', 'tih-book__option-rule', fill(T.notOn, { day: o.noDays.map(weekday).join(', ') })));
      lab.appendChild(t);
      if (o.price != null) lab.appendChild(el('span', 'tih-book__option-price', eur(o.price)));
      wrap.appendChild(lab);
    });
    return wrap;
  }
  function toggleKind(id, input) {
    var i = state.kinds.indexOf(id);
    if (input.checked && i < 0) {
      if (state.kinds.length >= 3) { input.checked = false; return flash(T.max3); }
      state.kinds.push(id);
    } else if (!input.checked && i >= 0) { state.kinds.splice(i, 1); delete state.options[id]; }
    var opts = root.querySelector('[data-kind="' + id + '"] .tih-book__options');
    if (opts) { opts.hidden = !input.checked; if (!input.checked) opts.querySelectorAll('input').forEach(function (r) { r.checked = false; }); }
    invalidate('kind'); update();
  }
  function kindsDone() {
    if (!state.kinds.length) return false;
    return state.kinds.every(function (id) { var k = kind(id); return !(k.options && k.options.length) || state.options[id] != null; });
  }

  /* ---------------------------------------------------------------- step 2: who (photo cards) */
  function allowed() {                       // who can be chosen: who can do it all, or with colour and a cut, who cuts
    return common(split() ? state.kinds.filter(function (id) { return !kind(id).colour; }) : state.kinds);
  }
  function avatar(s, cls) {
    var a = el('span', 'tih-book__avatar' + (cls ? ' ' + cls : ''));
    if (s && s.photo) { var img = el('img'); img.src = API + '/api/photo/' + s.id + '.jpg'; img.alt = ''; img.loading = 'lazy'; img.width = 64; img.height = 64; a.appendChild(img); }
    else a.textContent = s ? (s.name || '?').charAt(0) : '';
    return a;
  }
  function nameOf(id) { var s = byId(data.stylists, id); return s ? s.name : ''; }
  // Colour and a cut together (Martijn, 2026-10-17: he does not colour). One choice stays the main one, who cuts;
  // the colour goes to whoever of the colourists is free, said in one line, unless the customer opens the row and
  // picks one. A cutter who colours too does both, unless another colourist is picked.
  function renderColour() {
    var box = $('[data-colour]'), list = colourists();
    $('[data-who-title]').textContent = split() ? T.whoCut : T.whoTitle;
    box.textContent = ''; box.hidden = !split() || !list.length;
    if (box.hidden) return;
    var names = list.map(nameOf).filter(Boolean);
    var p = el('p', 'tih-book__colour-line');
    if (state.colourist) p.textContent = T.colourWho + ' ' + nameOf(state.colourist);
    else if (state.stylist && list.indexOf(state.stylist) >= 0) p.textContent = fill(T.colourSame, { name: nameOf(state.stylist) });
    else p.textContent = fill(T.colourBy, { names: names.length > 1 ? names.slice(0, -1).join(', ') + ' ' + T.or + ' ' + names[names.length - 1] : names.join('') });
    box.appendChild(p);
    var tog = el('button', 'tih-book__link', T.colourPick); tog.type = 'button';
    tog.setAttribute('aria-expanded', String(state.colourOpen)); tog.setAttribute('aria-controls', 'tih-book-colourists');
    tog.addEventListener('click', function () { state.colourOpen = !state.colourOpen; renderColour(); });
    box.appendChild(tog);
    var row = el('div', 'tih-book__colourists'); row.id = 'tih-book-colourists'; row.setAttribute('role', 'radiogroup');
    row.setAttribute('aria-label', T.colourWho); row.hidden = !state.colourOpen;
    [{ id: 0, name: T.colourAny }].concat(list.map(function (id) { return byId(data.stylists, id) || { id: id, name: nameOf(id) }; })).forEach(function (c) {
      var b = el('button', 'tih-book__chip'); b.type = 'button'; b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', String((state.colourist || 0) === c.id));
      if (c.id) b.appendChild(avatar(c, 'tih-book__avatar--mini'));
      b.appendChild(el('span', '', c.name));
      b.addEventListener('click', function () { state.colourist = c.id; invalidate('who'); renderColour(); update(); });
      row.appendChild(b);
    });
    box.appendChild(row);
  }
  function renderWho() {
    renderColour();
    var box = $('[data-who]'); box.textContent = '';
    var ok = allowed(), list = data.stylists.filter(function (s) { return ok.indexOf(s.id) >= 0; });
    if (state.stylist === null && state.me && state.me.lastStylist && ok.indexOf(state.me.lastStylist) >= 0) state.stylist = state.me.lastStylist;
    var opts = [{ id: 0, name: T.anyone, title: list.length > 1 ? T.most : '', any: true }].concat(list);
    opts.forEach(function (s) {
      var b = el('button', 'tih-book__person'); b.type = 'button'; b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', String(state.stylist === s.id));
      if (s.any) {
        var a = el('span', 'tih-book__avatar tih-book__avatar--any');
        list.slice(0, 3).forEach(function (x) { a.appendChild(avatar(x, 'tih-book__avatar--mini')); });
        b.appendChild(a);
      } else b.appendChild(avatar(s));
      var t = el('span', 'tih-book__person-txt'); t.appendChild(el('span', 'tih-book__person-name', s.name));
      if (s.title) t.appendChild(el('span', 'tih-book__person-title', s.title));
      b.appendChild(t);
      b.appendChild(el('span', 'tih-book__person-go', '→'));
      b.addEventListener('click', function () { state.stylist = s.id; invalidate('who'); go('when'); });
      box.appendChild(b);
    });
  }

  /* ---------------------------------------------------------------- step 3: day strip and times */
  function months() {
    var out = [], d = new Date(), end = data.lastDay ? new Date(data.lastDay + 'T12:00:00') : new Date(Date.now() + 84 * 864e5);
    d = new Date(d.getFullYear(), d.getMonth(), 1);
    while (d <= end) { out.push(d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0')); d = new Date(d.getFullYear(), d.getMonth() + 1, 1); }
    return out;
  }
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function renderWhen() {
    var strip = $('[data-days]'), times = $('[data-times]');
    strip.textContent = ''; times.textContent = ''; times.appendChild(el('p', 'tih-book__hint', T.loading));
    var key = JSON.stringify(ask());
    Promise.all(months().map(function (m) { return call('/api/dates', Object.assign(ask(), { month: m })); })).then(function (rs) {
      if (key !== JSON.stringify(ask()) || state.screen !== 'when') return;
      if (rs.some(function (r) { return r.error === 'limit'; })) return showError(T.err_limit);
      if (rs.some(function (r) { return !r.open; })) return down();
      state.open = {}; rs.forEach(function (r) { r.open.forEach(function (d) { state.open[d] = true; }); });
      var first = null, now = new Date(), end = data.lastDay ? new Date(data.lastDay + 'T12:00:00') : new Date(Date.now() + 84 * 864e5);
      for (var d = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12); d <= end; d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1, 12)) {
        var day = iso(d), open = !!state.open[day];
        var b = el('button', 'tih-book__day'); b.type = 'button'; b.setAttribute('role', 'radio'); b.setAttribute('data-iso', day);
        b.disabled = !open; b.setAttribute('aria-checked', String(day === state.date));
        b.setAttribute('aria-label', dayName(day, { weekday: 'long', day: 'numeric', month: 'long' }));
        b.appendChild(el('span', 'tih-book__dow', d.toLocaleDateString(LOCALE, { weekday: 'short' }).replace('.', '')));
        b.appendChild(el('span', 'tih-book__dnum', d.getDate()));
        if (d.getDate() === 1 || !strip.children.length) b.appendChild(el('span', 'tih-book__dmon', d.toLocaleDateString(LOCALE, { month: 'short' }).replace('.', '')));
        b.addEventListener('click', function () { pickDay(this.getAttribute('data-iso')); });
        strip.appendChild(b);
        if (open && !first) first = day;
      }
      if (!first) { times.textContent = ''; times.appendChild(el('p', 'tih-book__hint', T.noDays)); return; }
      pickDay(state.date && state.open[state.date] ? state.date : first);
    }, down);
  }
  function pickDay(day) {
    state.date = day; state.slot = null; update();
    $$('[data-days] .tih-book__day').forEach(function (b) {
      var on = b.getAttribute('data-iso') === day; b.setAttribute('aria-checked', String(on));
      if (on) { var s = b.parentNode; s.scrollLeft = b.offsetLeft - s.clientWidth / 2 + b.clientWidth / 2; }
    });
    $('[data-month-name]').textContent = dayName(day, { weekday: 'long', day: 'numeric', month: 'long' });
    var box = $('[data-times]'); box.textContent = ''; box.appendChild(el('p', 'tih-book__hint', T.loading));
    call('/api/times', Object.assign(ask(), { date: day })).then(function (r) {
      if (state.date !== day) return;
      box.textContent = '';
      if (!r.times) return r.error === 'limit' ? showError(T.err_limit) : down();
      if (!r.times.length) { box.appendChild(el('p', 'tih-book__hint', T.noTimes)); return; }
      var parts = [[T.morning, function (v) { return v < 12; }], [T.afternoon, function (v) { return v >= 12 && v < 17; }], [T.evening, function (v) { return v >= 17; }]];
      parts.forEach(function (p) {
        var list = r.times.filter(function (t) { return p[1](t.value); });
        if (!list.length) return;
        box.appendChild(el('h3', 'tih-book__part', p[0]));
        var grid = el('div', 'tih-book__slots'); grid.setAttribute('role', 'radiogroup'); grid.setAttribute('aria-label', p[0]);
        list.forEach(function (t) {
          var b = el('button', 'tih-book__slot'); b.type = 'button'; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false');
          // One spot per time. On "no preference" the service has already given it to whoever is least busy that day;
          // the name shows on the confirm step (Lucas, 2026-10-13), not here.
          b.appendChild(el('span', 'tih-book__slot-time', t.time));
          b.addEventListener('click', function () { state.slot = t; go('you'); });
          grid.appendChild(b);
        });
        box.appendChild(grid);
      });
    }, down);
  }

  /* ---------------------------------------------------------------- step 4: check and confirm */
  function renderYou() {
    var r = $('[data-review]'); r.textContent = '';
    var when = el('div', 'tih-book__review-when');
    when.appendChild(el('b', '', dayName(state.date, { weekday: 'long', day: 'numeric', month: 'long' })));
    var end = state.slot.end || hhmm(state.slot.value + minutes() / 60);
    when.appendChild(el('span', '', state.slot.time + '–' + end + (stylistName() ? ' · ' + T.with + ' ' + stylistName() : '')));
    r.appendChild(when);
    r.appendChild(renderPlan(state.slot));
    var ul = el('ul', 'tih-book__review-items');
    ordered().forEach(function (id) {
      var k = kind(id), li = el('li'), p = priceOf(id), o = state.options[id];
      li.appendChild(el('span', '', k.name + (o != null ? ' · ' + k.options[o].label : '')));
      li.appendChild(el('span', 'tih-book__review-price', p.v != null ? (p.from ? T.from + ' ' : '') + eur(p.v) : T.priceSalon));
      ul.appendChild(li);
    });
    var tot = total();
    if (tot.known && state.kinds.length > 1) {
      var li = el('li', 'tih-book__review-total'); li.appendChild(el('span', '', T.total));
      li.appendChild(el('span', 'tih-book__review-price', (tot.from ? T.from + ' ' : '') + eur(tot.sum))); ul.appendChild(li);
    }
    r.appendChild(ul);
    var planShown = !!(state.slot.plan && state.slot.plan.length > 1);      // the schedule above already shows the order
    if (!planShown && state.kinds.length > 1 && state.kinds.some(function (id) { return kind(id).colour; })) r.appendChild(el('p', 'tih-book__hint', T.colourFirst));
    $$('[data-guest-field]').forEach(function (l) { l.hidden = !!state.me; });
    var as = $('[data-as]'); as.hidden = !state.me;
    if (state.me) as.textContent = fill(T.bookAs, { name: state.me.name || state.me.email, email: state.me.email });
    hideError();
    if (!state.puzzle && !state.me) solvePuzzle();
  }
  // The booking as it will stand in the agenda, when there is more to it than one treatment by one person:
  // 14:15 colour with Laura, processing, 15:45 cut with Martijn, done around 16:30.
  function renderPlan(slot) {
    var plan = (slot && slot.plan) || [], ol = el('ol', 'tih-book__plan');
    var people = {}; plan.forEach(function (p) { if (p.stylist) people[p.stylist] = 1; });
    if (plan.length < 2 && !(plan[0] && plan[0].processing && kind(plan[0].id).colour)) { ol.hidden = true; return ol; }
    plan.forEach(function (p) {
      var li = el('li'); li.appendChild(el('span', 'tih-book__plan-time', p.start));
      li.appendChild(el('span', 'tih-book__plan-what', kind(p.id).name + (p.name && Object.keys(people).length > 1 ? ' · ' + T.with + ' ' + p.name : '')));
      ol.appendChild(li);
      // "inwerken" only for colour; another treatment's extra time (an up-do has 45 in MijnSalon) just counts in the end time
      if (p.processing && kind(p.id).colour) { var w = el('li', 'tih-book__plan-wait'); w.appendChild(el('span', 'tih-book__plan-time', '')); w.appendChild(el('span', 'tih-book__plan-what', T.processing + ' · ' + duration(p.processing))); ol.appendChild(w); }
    });
    if (slot.end) { var d = el('li', 'tih-book__plan-done'); d.appendChild(el('span', 'tih-book__plan-time', '')); d.appendChild(el('span', 'tih-book__plan-what', fill(T.ready, { time: slot.end }))); ol.appendChild(d); }
    return ol;
  }
  function solvePuzzle() {
    state.puzzle = 'solving';
    call('/api/challenge').then(function (c) {
      if (!c.challenge) { state.puzzle = null; return; }
      state.puzzleAt = Date.now();
      var enc = new TextEncoder(), n = 0;
      function hex(buf) { return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join(''); }
      (function batch() {
        var tries = [];
        for (var i = 0; i < 250 && n <= c.maxnumber; i++, n++) tries.push((function (k) {
          return crypto.subtle.digest('SHA-256', enc.encode(c.salt + k)).then(function (h) { return hex(h) === c.challenge ? k : -1; });
        })(n));
        Promise.all(tries).then(function (res) {
          var hit = res.filter(function (x) { return x >= 0; })[0];
          if (hit != null) state.puzzle = { algorithm: c.algorithm, challenge: c.challenge, salt: c.salt, signature: c.signature, number: hit };
          else if (n <= c.maxnumber) setTimeout(batch, 0);
          else state.puzzle = null;
        });
      })();
    }, function () { state.puzzle = null; });
  }
  function whenSolved() {
    return new Promise(function (resolve) {
      (function wait() {
        if (state.puzzle && state.puzzle !== 'solving') {
          var left = 5500 - (Date.now() - state.puzzleAt);     // the service refuses a puzzle answered within 5 seconds
          return left > 0 ? setTimeout(function () { resolve(state.puzzle); }, left) : resolve(state.puzzle);
        }
        if (!state.puzzle) solvePuzzle();
        setTimeout(wait, 150);
      })();
    });
  }
  function confirmBooking() {
    if (!state.me && !state.guest) { openLogin(); return; }
    hideError();
    var f = $('[data-form]');
    var v = { name: f.name.value.trim(), email: f.email.value.trim(), phone: f.phone.value.trim(), note: f.note.value.trim(), website: f.website.value };
    if (!state.me) {
      if (v.name.replace(/[^A-Za-zÀ-ÿ]/g, '').length < 2) return showError(T.err_name, f.name);
      if (!/^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/.test(v.email)) return showError(T.err_email, f.email);
      if (v.phone.replace(/\D/g, '').length < 9) return showError(T.err_phone, f.phone);
    }
    state.busy = true; update();
    (state.me ? Promise.resolve(null) : whenSolved()).then(function (puzzle) {
      return call('/api/book', Object.assign(ask(), { date: state.date, value: state.slot.value, slotStylist: state.slot.stylist || 0, slotColourist: state.slot.colourist || 0,
        name: v.name, email: v.email, phone: v.phone, note: v.note, website: v.website, puzzle: puzzle }));
    }).then(function (r) {
      state.puzzle = null; state.busy = false; update();
      if (r.ok) return done(r);
      var map = { name: [T.err_name, f.name], email: [T.err_email, f.email], phone: [T.err_phone, f.phone], taken: [T.err_taken], limit: [T.err_limit] };
      var m = map[r.error] || [T.err_other];
      if (r.error === 'taken') { state.slot = null; go('when'); flash(m[0]); return; }
      showError(m[0], m[1]);
      if (r.error === 'fast' || r.error === 'expired' || r.error === 'puzzle') solvePuzzle();
    }, function () { state.puzzle = null; state.busy = false; update(); down(); });
  }
  function done(r) {
    var mins = r.minutes || state.slot.minutes || minutes() || 45, start = state.date.replace(/-/g, '') + 'T' + state.slot.time.replace(':', '') + '00';
    var e = state.slot.value + mins / 60, endS = state.date.replace(/-/g, '') + 'T' + hhmm(e).replace(':', '') + '00';
    $('[data-done-when]').textContent = dayName(state.date, { weekday: 'long', day: 'numeric', month: 'long' }) + ' ' + T.at + ' ' + state.slot.time;
    $('[data-done-what]').textContent = ordered().map(function (id) { return kind(id).name; }).join(' + ') + (stylistName() ? ' · ' + T.with + ' ' + stylistName() : '');
    var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//This is happening//Afspraak//NL', 'BEGIN:VEVENT',
      'UID:' + start + '-' + Math.random().toString(36).slice(2) + '@this-is-happening.nl',
      'DTSTART;TZID=Europe/Amsterdam:' + start, 'DTEND;TZID=Europe/Amsterdam:' + endS,
      'SUMMARY:This is happening: ' + ordered().map(function (id) { return kind(id).name; }).join(' + '),
      'LOCATION:Haarlemmerdijk 40/42\\, 1013 JD Amsterdam', 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
    $('[data-ics]').href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics);
    show('done');
    if (state.me) loadMe();
  }

  /* ---------------------------------------------------------------- moving between steps */
  var ORDER = { kind: 0, who: 1, when: 2, you: 3, done: 4 };
  function invalidate(step) {                // a change in a step clears the choices that depend on it
    if (step === 'kind') {
      if (state.stylist && allowed().indexOf(state.stylist) < 0) state.stylist = null;
      if (state.colourist && colourists().indexOf(state.colourist) < 0) state.colourist = 0;
      state.date = null; state.slot = null;
    }
    if (step === 'who') { state.date = null; state.slot = null; }
  }
  function ready(step) {
    if (step === 'kind') return true;
    if (step === 'who') return kindsDone();
    if (step === 'when') return kindsDone() && state.stylist !== null;
    if (step === 'you') return ready('when') && !!state.slot;
    return false;
  }
  function go(step, fromHistory) {
    if (!state.me && !state.guest) return;
    if (!ready(step)) return;
    if (!fromHistory && step !== state.screen) { try { history.pushState({ tihBook: step }, ''); } catch (e) {} }
    show(step);
  }
  function show(step) {
    state.screen = step;
    STEPS.concat('done').forEach(function (s) { var x = $('[data-screen="' + s + '"]'); if (x) x.hidden = s !== step; });
    $('[data-intro]').hidden = step !== 'kind' || !!state.me || state.guest;
    $('[data-progress]').hidden = step === 'done';
    $('[data-bar]').hidden = step === 'done';
    $$('[data-p]').forEach(function (li) {
      var s = li.getAttribute('data-p'), b = li.querySelector('button');
      li.className = ORDER[s] < ORDER[step] ? 'is-done' : s === step ? 'is-here' : '';
      b.disabled = !(ORDER[s] < ORDER[step]);
      if (s === step) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
    });
    hideError();
    if (step === 'who') renderWho();
    if (step === 'when') renderWhen();
    if (step === 'you') renderYou();
    update();
    var target = step === 'done' ? $('[data-screen="done"]') : $('[data-progress]');
    var top = target.getBoundingClientRect().top + window.scrollY - 80;
    if (window.scrollY > top || step !== 'kind') window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    if (step === 'done') target.focus({ preventScroll: true });
  }
  function next() { return STEPS[STEPS.indexOf(state.screen) + 1]; }
  function update() {                        // the bar: price, what is chosen, and the next button
    var sum = $('[data-bar-sum]'), btn = $('[data-bar-go]'), tot = total(), n = state.kinds.length;
    sum.textContent = '';
    if (n) {
      sum.appendChild(el('b', '', tot.known ? (tot.from ? T.from + ' ' : '') + eur(tot.sum) : T.priceSalon));
      var meta = (n === 1 ? T.itemOne : fill(T.itemMany, { n: n })) + (minutes() ? ' · ' + duration((state.slot && state.slot.minutes) || minutes()) : '');
      if (state.screen !== 'kind' && stylistName()) meta += ' · ' + stylistName();
      if (state.screen !== 'you') sum.appendChild(el('span', '', meta));   // on the last step the card above says it all
    }
    if (state.screen === 'kind' && n && !kindsDone()) {
      var missing = state.kinds.filter(function (id) { var k = kind(id); return k.options && k.options.length && state.options[id] == null; })[0];
      if (missing != null) sum.appendChild(el('span', 'tih-book__bar-need', fill(T.needOption, { name: kind(missing).name })));
    }
    if (state.screen === 'you') { btn.textContent = state.busy ? T.working : T.confirm; btn.disabled = state.busy; }
    else { btn.textContent = T.next; var nx = next(); btn.disabled = !nx || !ready(nx); }
    // on "who" and "when" a tap on a card or a time moves on by itself; the button is there for the keyboard
    btn.hidden = (state.screen === 'who' && state.stylist === null) || (state.screen === 'when' && !state.slot);
  }

  /* ---------------------------------------------------------------- returning customers */
  function loginError(msg, ok) { var e = $('[data-login-error]'); e.textContent = msg; e.hidden = !msg; e.classList.toggle('is-ok', !!ok); }
  function openLogin() {
    state.guest = false; renderEntry();
    var f = $('[data-login-form]');
    (f.email.value ? f.password : f.email).focus();
    if (!state.puzzle) solvePuzzle();
  }
  function renderEntry() {
    var allowed = !!state.me || state.guest;
    $('[data-intro]').hidden = allowed || state.screen !== 'kind';
    $('[data-flow]').hidden = !allowed;
    $('[data-login-out]').hidden = allowed;
    $('[data-login-form]').hidden = allowed;
    $('[data-new-route]').hidden = allowed;
    $('[data-login-in]').hidden = !state.me;
    $('[data-guest-in]').hidden = !state.guest || !!state.me;
  }
  /* One login for two places: the line above the treatments, and step 4 for someone who only notices there.
     o = { email, pwField, emailField, btn, err(msg, ok), after(r) } */
  function signIn(o) {
    o.err('');
    var email = o.emailField.value.trim(), pw = o.pwField.value;
    if (!/^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/.test(email)) { o.err(T.err_email); return o.emailField.focus(); }
    if (!pw) { o.err(T.loginBad); return o.pwField.focus(); }
    var label = o.btn.textContent; o.btn.disabled = true; o.btn.textContent = T.loginWorking;
    whenSolved().then(function (puzzle) { return call('/api/login', { email: email, password: pw, puzzle: puzzle }); }).then(function (r) {
      state.puzzle = null; o.btn.disabled = false; o.btn.textContent = label;
      if (!r.ok) {
        if (r.error === 'fast' || r.error === 'expired' || r.error === 'puzzle') { solvePuzzle(); return signIn(o); }
        return o.err(r.error === 'limit' ? T.err_limit : T.loginBad);
      }
      o.pwField.value = ''; setSid(r.session); loggedIn(r); o.after(r);
    }, function () { state.puzzle = null; o.btn.disabled = false; o.btn.textContent = label; down(); });
  }
  function sendPassword(emailField, err) {
    var email = emailField.value.trim();
    if (!/^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/.test(email)) { err(T.resetNeedEmail); return emailField.focus(); }
    err(T.loginWorking, true);                 // the puzzle takes a few seconds; say so
    whenSolved().then(function (puzzle) { return call('/api/reset', { email: email, puzzle: puzzle }); }).then(function (r) {
      state.puzzle = null;
      if (r.error === 'fast' || r.error === 'expired' || r.error === 'puzzle') { solvePuzzle(); return sendPassword(emailField, err); }
      err(T.resetSent, true);
    }, down);
  }
  function login(e) {
    if (e) e.preventDefault();
    var f = $('[data-login-form]');
    signIn({ emailField: f.email, pwField: f.password, btn: $('[data-login-go]'), err: loginError, after: function () { restart(); } });
  }
  function reset() { sendPassword($('[data-login-form]').email, loginError); }
  function knownError(msg, ok) { var e = $('[data-known-error]'); e.textContent = msg; e.hidden = !msg; e.classList.toggle('is-ok', !!ok); }
  function knownOpen() {
    var box = $('[data-known-form]'), b = $('[data-known-open]');
    box.hidden = !box.hidden; b.setAttribute('aria-expanded', String(!box.hidden));
    if (!box.hidden) { $('[data-form]').kpassword.focus(); if (!state.puzzle) solvePuzzle(); }
  }
  function knownLogin() {
    var f = $('[data-form]');
    // logged in from step 4: keep the chosen treatment, day and time, and show the step again as theirs
    signIn({ emailField: f.email, pwField: f.kpassword, btn: $('[data-known-go]'), err: knownError, after: function () { renderYou(); update(); } });
  }
  function loggedIn(me) {
    state.me = me; state.guest = false; renderEntry();
    $('[data-login-name]').textContent = fill(T.loginIn, { name: me.firstName || me.name || me.email });
    loadMe();
  }
  function loggedOut(expired) {
    state.me = null; state.guest = false; renderEntry();
    $('[data-my-appointments]').textContent = '';
    if (expired) loginError(T.loggedOut);
    restart();
  }
  function loadMe() {
    call('/api/me').then(function (r) {
      var box = $('[data-my-appointments]'); box.textContent = '';
      if (!r.appointments || !r.appointments.length) return;
      box.appendChild(el('p', 'tih-book__my-h', T.myNext));
      var ul = el('ul', 'tih-book__my');
      r.appointments.slice(0, 3).forEach(function (a) {
        var d = new Date(a.start), when = isNaN(d) ? a.start : d.toLocaleDateString(LOCALE, { weekday: 'short', day: 'numeric', month: 'short' }) + ' ' + T.at + ' ' + a.start.slice(11, 16);
        ul.appendChild(el('li', '', [when, a.what, a.who ? T.with + ' ' + a.who : ''].filter(Boolean).join(' · ')));
      });
      box.appendChild(ul);
    });
  }
  function restart() {                       // a customer may see other treatments than a guest: start again
    state.kinds = []; state.options = {}; state.stylist = null; state.colourist = 0; state.colourOpen = false; state.date = null; state.slot = null;
    start();
  }

  /* ---------------------------------------------------------------- small things */
  function down() { boot(); showError(T.err_down); }
  function boot() { var b = $('[data-boot]'); if (b) b.remove(); }
  function showError(msg, field) {
    var e = state.screen === 'you' ? $('[data-error]') : null;
    if (e) { e.textContent = msg; e.hidden = false; } else flash(msg);
    if (field) field.focus();
  }
  function flash(msg) {
    var p = root.querySelector('.tih-book__alert') || el('p', 'tih-book__alert');
    p.setAttribute('role', 'alert'); p.textContent = msg;
    var bar = $('[data-bar]'); bar.parentNode.insertBefore(p, bar);
    clearTimeout(flash.t); flash.t = setTimeout(function () { if (p.parentNode) p.remove(); }, 7000);
  }
  function hideError() { var e = $('[data-error]'); if (e) e.hidden = true; var a = root.querySelector('.tih-book__alert'); if (a) a.remove(); }

  $('[data-bar-go]').addEventListener('click', function () { if (state.screen === 'you') confirmBooking(); else go(next()); });
  $$('[data-go-to]').forEach(function (b) { b.addEventListener('click', function () { go(b.getAttribute('data-go-to')); }); });
  window.addEventListener('popstate', function (e) {
    var s = (e.state && e.state.tihBook) || 'kind';
    if (state.screen === 'done') s = 'kind';
    if (ready(s)) show(s);
  });
  $('[data-login-open]').addEventListener('click', openLogin);
  $('[data-new-customer]').addEventListener('click', function () {
    state.guest = true; renderEntry(); show('kind');
    var heading = $('#tb-h-kind'); heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true });
  });
  $('[data-login-form]').addEventListener('submit', login);
  $('[data-reset]').addEventListener('click', reset);
  $('[data-known-open]').addEventListener('click', knownOpen);
  $('[data-known-go]').addEventListener('click', knownLogin);
  $('[data-known-reset]').addEventListener('click', function () { sendPassword($('[data-form]').email, knownError); });
  $('[data-form]').kpassword.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); knownLogin(); } });
  $('[data-logout]').addEventListener('click', function () { call('/api/logout', {}).then(function () { setSid(null); loggedOut(false); }); });
  $('[data-again]').addEventListener('click', function () { restart(); });

  function start() {
    Promise.all([call('/api/treatments?lang=' + LANG), call('/api/stylists')]).then(function (r) {
      if (!r[0].treatments || !r[1].stylists) return down();
      data.treatments = r[0].treatments; data.stylists = r[1].stylists; data.lastDay = r[0].lastDay;
      $('[data-terms]').textContent = r[0].terms || '';
      if (r[0].remarks === false) $('[data-note-field]').hidden = true;
      renderKinds(); boot();
      $('[data-app]').hidden = false;
      renderEntry();
      try { history.replaceState({ tihBook: 'kind' }, ''); } catch (e) {}
      show('kind');
    }, down);
  }
  var b0 = $('[data-boot]'); if (b0) b0.hidden = false;
  if (sid()) call('/api/me').then(function (r) { if (r && r.email) loggedIn(r); start(); }, start);
  else start();
})();
